// src/services/CountryService.js
import api from "./api";

export function getLanguage(page = 1, limit = 10, search = "") {
    return api.get(`/language?page=${page}&limit=${limit}&search=${search}`);
}

export function getLanguageById(id) {
    return api.get(`/language/${id}`);
}

export function addLanguage(data) {
    return api.post("/language", data);
}

export function updateLanguage(id, data) {
    return api.put(`/language/${id}`, data);
}

export function deleteLanguage(id) {
    return api.delete(`/language/${id}`);
}
